<script lang="ts" setup>
const route = useRoute<"variant">()

const productParam = computed(() => route.params.product)
const variantParam = computed(() => route.params.variant)

// Track the active tab based on the URL
const activeTabComputed = computed(() => {
  const path = route.path
  if (path.includes("min-side")) {
    return "profile"
  } else if (path.includes("sok")) {
    return "search"
  } else {
    return "home"
  }
})
</script>

<template>
  <nav>
    <ol
      class="flex w-screen items-end justify-center gap-4 bg-[--theme-darkest] px-1 pb-4 pt-1.5 md:hidden"
    >
      <li>
        <UButton
          theme="light"
          variant="outline"
          stacked
          size="sm"
          :class="
            activeTabComputed === 'home'
              ? '!text-white'
              : 'brightness-[85%]'
          "
          class="!w-[85px] hover:!text-white"
          :to="`/produkter/${productParam}/${variantParam}`"
          :aria-current="
            activeTabComputed === 'home' ? 'page' : undefined
          "
        >
          <template #prepend>
            <UIcon
              name="k"
              class="mb-2"
              size="lg"
            />
          </template>
          Hjem
        </UButton>
      </li>
      <li>
        <UButton
          theme="light"
          variant="outline"
          class="!w-[85px] hover:!text-white"
          :class="
            activeTabComputed === 'search'
              ? '!text-white'
              : 'brightness-[85%]'
          "
          stacked
          size="sm"
          :to="
            `/produkter/${[route.params.product, route.params.variant]
              .filter(Boolean)
              .join('/')}` + '/sok'
          "
          :aria-current="
            activeTabComputed === 'search' ? 'page' : undefined
          "
        >
          <template #prepend>
            <UIcon
              name="search"
              class="mb-2"
              size="lg"
            />
          </template>
          Søk
        </UButton>
      </li>
      <li>
        <UMyProfileButton
          mobile
          class="!w-[85px] hover:!text-white"
          :class="
            activeTabComputed === 'profile'
              ? '!text-white'
              : 'brightness-[85%]'
          "
          :path="[route.params.product, route.params.variant]"
          :aria-current="
            activeTabComputed === 'profile' ? 'page' : undefined
          "
        />
      </li>
    </ol>
  </nav>
</template>
